import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { AppConfig } from '../../config';

@Injectable()
export class HomeService {

  constructor(private _http: Http) { }

  brojPoslodavaca(a: any){
    return this._http.put(AppConfig.apiAdresaMongoVimeo + 'users/prebrojPoslodavce', a)    
    .map(res => res.json()); 
  }

  brojPosloprimaca(a: any){
    return this._http.put(AppConfig.apiAdresaMongoVimeo + 'users/prebrojPosloprimce', a)    
    .map(res => res.json()); 
  }

  brojNatjecaja(a: any){
    return this._http.put(AppConfig.apiAdresaMongoVimeo + 'onatjecaji/prebrojNatjecaje', a)    
    .map(res => res.json()); 
  }

  brojZavrsenihNatjecaja(a: any){
    return this._http.put(AppConfig.apiAdresaMongoVimeo + 'znatjecaji/prebrojNatjecaje', a)    
    .map(res => res.json()); 
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/home/home.service.ts